import type { IconData } from '@stacksjs/iconify-core'

export const shoppingBag: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4 4H0v4a8 8 0 1 0 16 0V4h-4a4 4 0 0 0-8 0m2 0h4a2 2 0 1 0-4 0\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default shoppingBag
